var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-main-box"},[_c('CommonDetail',{attrs:{"detailData":_vm.billInstallDetailData,"pageType":"billInstall","praData":_vm.pra}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }